import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

function Navbar() {
  const { user, logout } = useAuth();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          <img src="/logo.png" alt="Logo" className="navbar-logo" />
          La Lengua
        </Link>

        <div className="navbar-links">
          <Link
            to="/"
            className={`navbar-link ${isActive('/') ? 'active' : ''}`}
          >
            Home
          </Link>
          <Link
            to="/categories"
            className={`navbar-link ${isActive('/categories') ? 'active' : ''}`}
          >
            Categories
          </Link>
          <Link
            to="/rules"
            className={`navbar-link ${isActive('/rules') ? 'active' : ''}`}
          >
            Rules
          </Link>
          {user?.isAdmin && (
            <Link
              to="/admin/winners"
              className={`navbar-link ${isActive('/admin/winners') ? 'active' : ''}`}
            >
              Admin
            </Link>
          )}
        </div>

        <div className="navbar-user">
          <span className="navbar-username">{user?.name}</span>
          <button onClick={handleLogout} className="navbar-logout">
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
